
import ModalContainer from '~/components/modal/Container';
import Header from '~/components/Header';
import baseLayout from '~/layouts/base';
import ErrorOverlay from '~/components/global/ErrorOverlay.vue';

export default {
    name: 'defaultLayout',
    extends: baseLayout,
    components: {
        ErrorOverlay,
        ModalContainer,
        Header,
    },
    computed: {
        isLoggedIn() {
            return this.$auth.loggedIn;
        },
    },
};
